import { Col, Drawer, Flex, Form, Modal, Row, Typography } from "antd";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { useEffect } from "react";
import { setTitle } from "../../../../redux/slices/configuracoes/configuracoesSlice";
import { atualizarEmpresaAtivo, buscarEmpresa, deletarEmpresa } from "../../../../services/empresaService";
import { listarEstado } from "../../../../services/localizacaoService";
import { buscarGrupoPlanoContaFinanceiro } from "../../../../services/grupoPlanoContaFinanceiroService";
import { buscarCategoriaEmpresa } from "../../../../services/categoriaEmpresaService";
import { setBuscaEmpresa, setEntityEmpresa, setModalDeletarEmpresa, setModalVisualizarEmpresa, setPageEmpresa } from "../../../../redux/slices/empresa/empresaSlice";
import { EmpresaModel } from "../../../../models/empresa/empresaModel";
import { AtivoModel } from "../../../../models/ativoModel";
import { ItemMenuAcoes } from "../../../../models/sistema/itemMenuAcoes";
import * as Icon from "@ant-design/icons";
import { ColumnsType } from "antd/lib/table";
import { ListaEmpresaDTOModel } from "../../../../models/empresa/listaEmpresaDTOModel";
import { formatCPFCNPJ } from "../../../../util/formats";
import AcoesComponent from "../../../../components/table/acoesComponent";
import Search from "antd/es/input/Search";
import TableComponent from "../../../../components/table/tableComponent";
import MensagemModal from "../../../../components/modal/mensagem";
import VisualizarEmpresa from "../../modals/visualizar";
import { ButtonComponent } from "../../../../components/button/cadastrar";
import { SwitchComponent } from "../../../../components/button/switch";

const GeralPage = () => {
  //estados globais
  const empresaState = useAppSelector((state) => state.empresa);
  const localizacaoState = useAppSelector((state) => state.localizacao);
  const grupoPlanoContaFinanceiroState = useAppSelector((state) => state.grupoPlanoContaFinanceiro);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(setTitle("EMPRESAS"));
    dispatch(buscarEmpresa(empresaState.busca));
    dispatch(listarEstado());
    dispatch(buscarGrupoPlanoContaFinanceiro(grupoPlanoContaFinanceiroState.busca));
    dispatch(buscarCategoriaEmpresa());
    form.setFieldsValue({ pesquisar: empresaState.busca });
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityEmpresa({}));
    dispatch(setPageEmpresa("cadastrar"));
  };

  const goEditar = (empresa: EmpresaModel) => {
    dispatch(setEntityEmpresa(empresa));
    dispatch(setPageEmpresa("cadastrar"));
  };

  const goDeletar = (empresa: EmpresaModel) => {
    dispatch(setEntityEmpresa(empresa));
    dispatch(setModalDeletarEmpresa(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarEmpresa(false));
  };

  const goVisualizar = (empresa: EmpresaModel) => {
    dispatch(setEntityEmpresa(empresa));
    dispatch(setModalVisualizarEmpresa(true));
  };

  const closeModalVisualizar = () => {
    dispatch(setModalVisualizarEmpresa(false));
  };

  const onChangeAtivo = (empresa: EmpresaModel) => {
    let args: AtivoModel = {
      id: empresa.id,
      ativo: !empresa.ativo,
    };
    dispatch(atualizarEmpresaAtivo({ value: args, busca: empresaState.busca }));
  };

  const onSearch = (value: string) => {
    dispatch(setBuscaEmpresa(value.replace(/\./g, "")));
    dispatch(buscarEmpresa(value.replace(/\./g, "")));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<ListaEmpresaDTOModel> = [
    {
      title: "APELIDO",
      dataIndex: "apelido",
      sorter: (a, b) => a.apelido.localeCompare(b.apelido),
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => (
        <Typography.Text style={{ width: 150 }} ellipsis={{ tooltip: record.apelido }}>
          {record.apelido}
        </Typography.Text>
      ),
    },
    {
      title: "RAZÃO SOCIAL",
      dataIndex: "razaoSocial",
      sorter: (a, b) => a.razaoSocial.localeCompare(b.razaoSocial),
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => (
        <Typography.Text style={{ width: 150 }} ellipsis={{ tooltip: record.razaoSocial }}>
          {record.razaoSocial}
        </Typography.Text>
      ),
    },
    {
      title: "CPF/CNPJ",
      dataIndex: "cpfcnpj",
      render: (_, record) => formatCPFCNPJ(record.cpfcnpj),
    },
    {
      title: "CIDADE",
      dataIndex: "cidade",
      sorter: (a, b) => a.cidade?.localeCompare(b.cidade),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "ESTADO",
      dataIndex: "idEstado",
      render: (_, record) => {
        return <>{localizacaoState.listEstado.find((a: any) => a.id === record.idEstado)?.denominacao}</>;
      },
    },
    {
      title: "CATEGORIA",
      dataIndex: "categoriaEmpresa",
      align: "center",
      sorter: (a, b) => a.categoriaEmpresa.localeCompare(b.categoriaEmpresa),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "GRUPO PLANO CONTA FINANCEIRO",
      dataIndex: "grupoPlanoContaFinanceiro",
      align: "center",
      sorter: (a, b) => a.grupoPlanoContaFinanceiro.localeCompare(b.grupoPlanoContaFinanceiro),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "ATIVO",
      dataIndex: "ativo",
      align: "right",
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      filters: [
        {
          text: "Ativo",
          value: "true" as any,
        },
        {
          text: "Inativo",
          value: "false" as any,
        },
      ],
      onFilter: (value: any, record: any) => record.ativo.toString().includes(value),
      defaultFilteredValue: ["true" as any],
      render: (_: any, record: any) => <SwitchComponent checked={record.ativo} onChange={() => onChangeAtivo(record)} />,
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item label="Pesquisar" name="pesquisar">
                <Search allowClear placeholder="Apelido, Razão Social ou CPF/CNPJ" onSearch={onSearch} style={{ width: 350 }} className="searchInput" enterButton />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastrar} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent
        data={empresaState.list}
        columns={columns}
        loading={empresaState.loading}
        tableProps={{
          onRow: (record: ListaEmpresaDTOModel) => {
            return {
              onClick: (event: any) => {
                event.stopPropagation();
                goVisualizar(record);
              },
            };
          },
        }}
      />
      <Modal title={"REMOVER EMPRESA"} centered width={350} open={empresaState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal text="Deseja remover a empresa?" action={deletarEmpresa({ value: empresaState.entity.id, busca: empresaState.busca })} close={setModalDeletarEmpresa(false)} />
      </Modal>
      <Drawer title="VISUALIZAR EMPRESA" placement="right" onClose={closeModalVisualizar} open={empresaState.modalVisualizar} getContainer={false} destroyOnHidden>
        <VisualizarEmpresa />
      </Drawer>
    </Flex>
  );
};

export default GeralPage;
